var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import cookie from '../../../cookie/cookie';
import firstFilterCondition from '../../console-common/first-filter-condition.vue';
import secFilterCondition from '../../console-common/sec-query-condition.vue';
export default Vue.extend({
    name: 'fundLoanManageFilterCondition',
    components: {
        'custom-first-filter-condition': firstFilterCondition,
        'custom-sec-filter-condition': secFilterCondition,
    },
    data: function () {
        var _this = this;
        return {
            capitalCode: '',
            firstFilterCondition: {},
            firstFilterConditionConfig: [
                {
                    type: 'normal',
                    label: '线下合同号',
                    key: 'contractCode',
                },
                {
                    type: 'search',
                    label: '商户名称',
                    key: 'tenantCode',
                    options: [],
                    remoteMethod: function (val) {
                        _this['getTenantList'](val);
                    },
                    clearCallback: function () {
                        _this['getTenantList']();
                    },
                },
                {
                    type: 'select',
                    label: '订单状态',
                    key: 'status',
                    options: [
                        {
                            label: '正常',
                            value: 'NORMAL',
                        },
                        {
                            label: '逾期',
                            value: 'OVERDUE',
                        },
                        {
                            label: '已还清',
                            value: 'PAID_OFF',
                        },
                        {
                            label: '已终止',
                            value: 'TERMINAL',
                        },
                    ],
                },
                {
                    type: 'radio',
                    label: '代扣协议',
                    key: 'signStatus',
                    radios: [
                        {
                            label: '',
                            text: '全部',
                        },
                        {
                            label: 'SIGNED',
                            text: '已签署',
                        },
                        {
                            label: 'NOT_SIGN',
                            text: '未签署',
                        },
                    ],
                    defaultValue: '',
                },
            ],
            secOptBtns: [
                {
                    type: 'primary',
                    class: {
                        'el-icon-circle-plus-outline': true,
                    },
                    btnText: '新建订单',
                    callback: function () {
                        _this.$router.push({
                            path: 'loan-order-list/loan-create',
                        });
                    },
                },
            ],
        };
    },
    computed: __assign({}, mapState('fundLoanManage', {
        tenantCodeList: 'tenantCodeList',
    }), { filterCondition: function () {
            return Object.assign({}, this.firstFilterCondition);
        } }),
    watch: {
        tenantCodeList: function (val) {
            this.firstFilterConditionConfig[1].options = val;
        },
        filterCondition: {
            deep: true,
            handler: function (val) {
                this.$emit('get-param', val);
            },
        },
    },
    created: function () {
        this.getCapitalCode();
        this.getTenantList();
    },
    methods: {
        getCapitalCode: function () {
            this.capitalCode = cookie.getCookie('dafs_merchant_id');
        },
        getTenantList: function (tenantName) {
            if (tenantName === void 0) { tenantName = ''; }
            this.$store.dispatch('fundLoanManage/GET_TENANTLIST', {
                tenantName: tenantName,
                capitalCode: this.capitalCode,
            });
        },
        getFirstFilterCondition: function (param) {
            this.firstFilterCondition = param;
        },
    },
});
